import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpParams,
  HttpRequest
} from '@angular/common/http';
import { Observable } from 'rxjs';
import Utils from '../shared/utils';

export class UserInterceptor implements HttpInterceptor {

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let params = new HttpParams({fromString: req.params.toString()});
    const uuid = Utils.getUserUuid();
    params = params.append('userId', Utils.getUserId() || '');
    if (uuid !== 'undefined') {
      params = params.append('uuid', uuid);
    }
    const clonedRequest = req.clone({params});
    return next.handle(clonedRequest);
  }

}
